const InstitutionTypes = {
  bank: {
    id: 1,
    name: 'bank',
    text: 'Bank',
    key: 'BANK',
  },
  nonBankFinancialInstitution: {
    id: 2,
    name: 'nonBankFinancialInstitution',
    text: 'Non-bank financial institution',
    key: 'NON_BANK_FINANCIAL_INSTITUTION',
  },
  business: {
    id: 3,
    name: 'business',
    text: 'Business',
    key: 'BUSINESS',
  },
  faithBased: {
    id: 4,
    name: 'faithBased',
    text: 'Faith-based',
    key: 'FAITH_BASED',
  },
  foundation: {
    id: 5,
    name: 'foundation',
    text: 'Foundation',
    key: 'FOUNDATION',
  },
  nonProfit: {
    id: 6,
    name: 'nonProfit',
    text: 'Non-profit',
    key: 'NON_PROFIT',
  },
  other: {
    id: 7,
    name: 'other',
    text: 'Other',
    key: 'OTHER',
  },
};

export default InstitutionTypes;



// WEBPACK FOOTER //
// ./src/data/static/institutionTypes.js